import { React, useState } from "react"
import Accordion from "react-bootstrap/Accordion";
import { Col, Row } from "react-bootstrap";

import { ProgressMainTable, StackedColumnChart } from "./";
import { Common } from "../../../helper";
import { DetailedViewTable } from "../PredictedPassRates";

import "../../../assets/stlyes/BigPicture/EOYP.scss";

import AccordionUp from "../../../assets/images/AccordionUp.png";
import AccordionDown from "../../../assets/images/AccordionDown.png";
import PPRArrow from "../../../assets/images/VectorPPRArrow.svg";

const SubjectAccordion = (props) => {
  const { subject, index, toggleAccordion, activeAccordionIndex } = props;
  const [graphView, listView] = useState(true);
  const [studentDetails, setStudentDetails] = useState();
  
  return (
    <div className="subject-accordion">
      <Accordion activeKey={activeAccordionIndex} onSelect={() => toggleAccordion(index)}>
        <Accordion.Item eventKey={index}>
          <Accordion.Header>{Object.keys(subject)}<img alt="" src={activeAccordionIndex === index ? AccordionUp : AccordionDown} /></Accordion.Header>
          <Accordion.Body className="accordion-body_">
            <div style={{ display: "flex", alignItems: "center", width: "-webkit-fill-available" }}>
              <div className="legend">
                <div className="legendNames"><div className="greenPointer_" style={{ backgroundColor: "var(--exceeding-color)" }} />&nbsp;{Common.Exceeding}</div>
                <div className="legendNames"><div className="greenPointer_" style={{ backgroundColor: "var(--ontrack-color)" }} /> &nbsp;{Common.OnTrack_}</div>
                <div className="legendNames"><div className="greenPointer_" style={{ backgroundColor: "var(--not-ontrack-color)" }} />&nbsp;{Common.NotOnTrack}</div>
                <div className="legendNames"><div className="greenPointer_" style={{ backgroundColor: "var(--unknown-color)" }} /> &nbsp;{Common.Unkown}</div>
              </div>
              <StackedColumnChart subject={subject} />
            </div>
            <div style={{ width: "-webkit-fill-available" }}>
              {graphView ? <ProgressMainTable setStudentDetails={setStudentDetails} subject={subject} listView={listView}/>:
                studentDetails && <Row>
                  <button onClick={() => listView(true)} className="back-button"><img src={PPRArrow} alt="" />&nbsp;{Common.BackToKeyInsight}</button>
                  <Col sm={12}>
                    <DetailedViewTable studentDetails={studentDetails} isPassing={false}/>
                  </Col>
                </Row>}
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  )
}

export { SubjectAccordion }